export default __webpack_public_path__ + "static/media/mc_settings_pulse.1ef5ffda.svg";